export enum ReportType {
    'VMR' = 'VMR',
    'DRILLING' = 'DRILLING',
    'WELL_COMPLETION' = 'WELL_COMPLETION',
    'WELL_CONSTRUCTION' = 'WELL_CONSTRUCTION',
    'TRAJECTORY' = 'TRAJECTORY',
    'MUD' = 'MUD',
    'CHISEL' = 'CHISEL',
    'BHA_RUN' = 'BHA_RUN',
    'MTR' = 'MTR',
    'CHEMICAL_REAGENT_CONSUMPTION' = 'CHEMICAL_REAGENT_CONSUMPTION',
    'TECHNIQUE' = 'TECHNIQUE',
    'NPV' = 'NPV',
    'OT_PB' = 'OT_PB',
    'BKV' = 'BKV',
    'GGD' = 'GGD',
    'PNV' = 'PNV',
    'ADDITIONAL_WORK' = 'ADDITIONAL_WORK',
    'SUPERVISING_VIOLATIONS' = 'SUPERVISING_VIOLATIONS',
    'PIT' = 'PIT',
    'NPV_WITHOUT_REPAIR' = 'NPV_WITHOUT_REPAIR',
    'NPV_REPAIR' = 'NPV_REPAIR',
}

export const reportsOptionsTitleMap: {[key in ReportType]: string} = {
    [ReportType.BKV]: 'constants.bkv',
    [ReportType.DRILLING]: 'drilling',
    [ReportType.MUD]: 'constants.mud',
    [ReportType.CHEMICAL_REAGENT_CONSUMPTION]: 'constants.chemicalReagentConsumption',
    [ReportType.WELL_CONSTRUCTION]: 'constants.construction',
    [ReportType.CHISEL]: 'constants.chisels',
    [ReportType.MTR]: 'abbr.mtr',
    [ReportType.NPV]: 'abbr.npv',
    [ReportType.WELL_COMPLETION]: 'completion',
    [ReportType.OT_PB]: 'abbr.otAndPb',
    [ReportType.BHA_RUN]: 'runs',
    [ReportType.TECHNIQUE]: 'constants.technique',
    [ReportType.TRAJECTORY]: 'trajectory',
    [ReportType.VMR]: 'abbr.vmr',
    [ReportType.PNV]: 'abbr.pnv',
    [ReportType.ADDITIONAL_WORK]: 'additionalWork',
    [ReportType.SUPERVISING_VIOLATIONS]: 'supervisingViolations',
    [ReportType.GGD]: 'abbr.ggd',
    [ReportType.PIT]: 'abbr.pit',
    [ReportType.NPV_WITHOUT_REPAIR]: 'abbr.npv',
    [ReportType.NPV_REPAIR]: 'repairs',
};
